import React, { useRef } from 'react';
import { useDedupEffect } from './useDedupEffect';
import * as style from '../styles'
import { ClockProps } from '../types';

function Clock({ updateInterval = 1000, className, locale }: ClockProps) {
  const dateTimeRef = useRef<HTMLSpanElement>(null);

  useDedupEffect(() => {
    const intervalId = setInterval(() => {
      const d = new Date();
      if (dateTimeRef.current) {
        dateTimeRef.current.innerText = d.toLocaleString(locale);
      }
    }, updateInterval);

    return () => clearInterval(intervalId);
  }, []);

  return <span ref={dateTimeRef} className={className} style={style.clockIconStyle} />;
}

export default Clock;
